import React, { Fragment} from "react";

const NotFound = () => (
    <Fragment>
      <h1>Nothing found</h1>
      <p>Sorry, you have typed an URL that does not exist.</p>
    </Fragment>
);

export default NotFound;